import React, { useEffect, useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";

import DupontCheckbox from "components/DupontCheckbox/index.js";
import DupontIconButton from "components/DupontIconButton/index.js";
import InputBox from "components/InputBox";

import Alarming from "assets/SystemsAndAlarms/status_Alarming_filter.svg";
import Idle from "assets/SystemsAndAlarms/status_Idle_filter.svg";
import Offline from "assets/SystemsAndAlarms/status_Offline_filter.svg";
import Online from "assets/SystemsAndAlarms/status_Running_filter.svg";

import FilterIcon from "../../assets/SvgIcon/Filter/filter.js";
import { AlarmPageStrings, landingPageStrings, valueStrings } from "../../constants/constantStrings";
import { getItemSession, removeItemSession, saveItemSession } from "../../utils/session";

import "./index.css";

const status = [
  { img: null, name: landingPageStrings.all, connectionStatus: "", systemStatus: "", checked: false },
  { img: Offline, name: landingPageStrings.offline, connectionStatus: "0", systemStatus: "0", checked: false },
  { img: Online, name: landingPageStrings.online, connectionStatus: "1", systemStatus: "1", checked: false },
  { img: Alarming, name: landingPageStrings.alarming, connectionStatus: "1", systemStatus: "2", checked: false },
  { img: Idle, name: landingPageStrings.idle, connectionStatus: "1", systemStatus: "0", checked: false }
];

const Filter = ({
  data,
  setFilterValue,
  showfilter,
  placeholder,
  selectedSystem,
  setselectedSystem,
  setShowTableFilterIcon,
  showTableFilterIcon,
  customWidth = "250px",
  customClass,
  landingPageView
}) => {
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  let filterValue;
  customClass = customClass || "filterPadding";

  useEffect(() => {
    const noneSelected = status.every(stat => stat.checked === false);
    const selectedStatuses = getItemSession("checkedStatus");
    if (noneSelected && (!selectedStatuses || selectedStatuses.length === 0)) status[0].checked = true;
    else if (selectedStatuses) {
      const arraySelectedStatusess = selectedStatuses.split(",");
      arraySelectedStatusess.forEach(element => {
        const filterStatus = status.filter(item => item.name === element);
        if (filterStatus && filterStatus.length > 0) filterStatus[0].checked = true;
      });
    }
  }, []);

  const handleFilterChange = value => {
    filterValue = value;
    const trimmedVal = value?.trim() || "";
    setFilterValue(trimmedVal);
  };

  const onFilterDropdownClick = () => {
    setIsFilterDropdownOpen(!isFilterDropdownOpen);
  };
  const applyFilterClick = () => {
    setShowTableFilterIcon(!showTableFilterIcon);
  };

  const handleClick = (checked, checkedIndex) => {
    status[checkedIndex].checked = checked;
    const noneSelected = !status.some(stat => stat.checked);

    if (checkedIndex === 0) {
      for (let key = 1; key < status.length; key++) {
        status[key].checked = false;
      }
    } else status[0].checked = noneSelected;

    const selectedSystem = status.filter(item => item.checked);
    setselectedSystem(selectedSystem);
    const selectedStatus = selectedSystem.map(function (item) {
      return item.name;
    });
    saveItemSession("filteredSystems", JSON.stringify(selectedSystem));
    if (checkedIndex === 0) {
      removeItemSession("checkedStatus");
    } else {
      saveItemSession("checkedStatus", selectedStatus);
    }
  };

  const getCheckedStatus = (name, checked) => {
    const names = getItemSession("checkedStatus");
    if (names && names.includes(name)) {
      const isChecked = names && names.includes(name);
      const filterStatus = status.filter(item => item.name === name);
      filterStatus[0].checked = isChecked;
      return isChecked;
    } else if ((!names || names.length === 0) && name.trim().includes("All")) {
      return true;
    }
    return checked;
  };

  const showFilter = {
    display: showfilter ? "block" : "none"
  };
  const tableFilterIconPosition = {
    position: !showfilter ? "fixed" : ""
  };

  return (
    <div className={`d-flex filterParent fullWidth ${customClass}`}>
      <div className={!showfilter ? "margin-left-40" : "margin-right-10"} style={{ width: customWidth }}>
        <InputBox
          id="filter-search-box"
          autoComplete="off"
          placeholder={placeholder || AlarmPageStrings.searchHere}
          value={filterValue}
          onChange={handleFilterChange}
          isSearchBox={true}
          disabled={data?.length === 0}
        />
      </div>
      {landingPageView !== "cards" ? (
        <div style={tableFilterIconPosition} className="pointer" onClick={data?.length === 0 ? "" : applyFilterClick}>
          <DupontIconButton id="filter-icon-btn" customClass="no-bg" tooltip={valueStrings.filter} disabled={data?.length === 0} >
            {<FilterIcon active={showTableFilterIcon} disabled={data?.length === 0} />}
          </DupontIconButton>
        </div>
      ) : (
        <>
          <div style={showFilter}>
            <Dropdown isOpen={isFilterDropdownOpen} className="pointer" toggle={onFilterDropdownClick}>
              <DropdownToggle tag="span">
                <DupontIconButton id="active-filter-icon-btn" tooltip={valueStrings.filter}>
                  {<FilterIcon open={isFilterDropdownOpen} active={selectedSystem?.length > 0 && status[0].checked !== true} />}
                </DupontIconButton>
              </DropdownToggle>
              <DropdownMenu className="dropStyleMenu">
                <div className="user-Modal">
                  <ul className="ul-List">
                    {status.map((stat, index) => (
                      <li className="padding5 descriptionText li-List" key={index} value={stat}>
                        <div className="flex-between-center">
                          <DupontCheckbox
                            checked={getCheckedStatus(stat.name, stat.checked)}
                            name={index}
                            labelText={stat.name}
                            onChange={handleClick}
                            customClass="flex-ai-center margin-bottom-0 "
                          />
                          {stat.name !== landingPageStrings.all && <img className="filter-icon" alt='filter-icon' src={stat.img} />}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </>
      )}
    </div>
  );
};

{
  /* FilterSystemsAndAlarms.defaultProps = { placeholder: landingPageStrings.search } */
}
export default Filter;
